export default __webpack_public_path__ + "static/media/products-4.9bc7c62b.webp";